// extracted by mini-css-extract-plugin
export default {"text":"style_text__TR+XQ","quantityOfIdsText":"style_quantityOfIdsText__yJ4Kj"};